import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'bt-order-ready-for-pickup-modal',
	standalone: false,
	templateUrl: './order-ready-for-pickup-modal.component.html',
	styleUrl: './order-ready-for-pickup-modal.component.scss'
})
export class OrderReadyForPickupModalComponent {
	data = inject<any>(MAT_DIALOG_DATA);
	loading = false;
	isDragging = false;

	constructor(private dialogRef: MatDialogRef<OrderReadyForPickupModalComponent>) {}

	close(): void {
		this.dialogRef.close();
	}
}
